const EngineSize = [
  { label: '0.5 ltr', value: 500 },
  { label: '1 ltr', value: 1000 },
  { label: '1.2 ltr', value: 1200 },
  { label: '1.3 ltr', value: 1300 },
  { label: '1.4 ltr', value: 1400 },
  { label: '1.5 ltr', value: 1500 },
  { label: '1.6 ltr', value: 1600 },
  { label: '1.8 ltr', value: 1800 },
  { label: '1.9 ltr', value: 1900 },
  { label: '2 ltr', value: 2000 },
  { label: '2.5 ltr', value: 2500 },
  { label: '3 ltr', value: 3000 },
  { label: '4 ltr', value: 4000 },
  { label: '5 ltr', value: 5000 },
  { label: '6 ltr', value: 6000 },
  { label: '7 ltr', value: 7000 },
  { label: '8 ltr', value: 8000 },
  { label: '9 ltr', value: 9000 },
]

export default EngineSize
